/**
 * returning the amount of the progress bar
 * @param {object} browserHistory  from the state
 */
export const getProgressValue = browserHistory => {
  switch (browserHistory.getCurrentLocation().pathname) {
    case '/discover/source':
      return 0;
    case '/discover/ids':
      return 16.66;
    case '/discover/listingSelect':
      return 33.33;
    case '/discover/selectAccount':
      return 49.98;
    case '/discover/strategy':
      return 66.64;
    case '/discover/singleResult':
      return 83.3;
    case '/discover/multiResult':
      return 83.3;
    default:
      return 0;
  }
};

/**
 * switcher for rendering the steps progress
 * @param {object} data object of discoveryStore, callBack and state
 */
export const renderProgressTags = data => {
  switch (data.pathname) {
    case '/discover/ids':
      return [
        data.tagConstructor(
          1,
          'discover.DiscoverAndList',
          data.getDiscoverMarket,
          'sourceMarketplace',
          '/discover/source',
        ),
      ];
    case '/discover/listingSelect':
      return [
        data.tagConstructor(
          1,
          'discover.DiscoverAndList',
          data.getDiscoverMarket,
          'sourceMarketplace',
          '/discover/source',
        ),
        data.tagConstructor(
          2,
          'discovery.method',
          data.getDiscoverMethod,
          'discoveryMethods',
          '/discover/ids',
        ),
      ];
    case '/discover/selectAccount':
      return [
        data.tagConstructor(
          1,
          'discover.DiscoverAndList',
          data.getDiscoverMarket,
          'sourceMarketplace',
          '/discover/source',
        ),
        data.tagConstructor(
          2,
          'discovery.method',
          data.getDiscoverMethod,
          'discoveryMethods',
          '/discover/ids',
        ),
        data.tagConstructor(
          3,
          'discovery.destination',
          data.getListingMarket,
          'destinationMarketplace',
          '/discover/listingSelect',
        ),
      ];
    case '/discover/strategy':
      return [
        data.tagConstructor(
          1,
          'discover.DiscoverAndList',
          data.getDiscoverMarket,
          'sourceMarketplace',
          '/discover/source',
        ),
        data.tagConstructor(
          2,
          'discovery.method',
          data.getDiscoverMethod,
          'discoveryMethods',
          '/discover/ids',
        ),
        data.tagConstructor(
          3,
          'discovery.destination',
          data.getListingMarket,
          'destinationMarketplace',
          '/discover/listingSelect',
        ),
        data.tagConstructor(
          4,
          'discover.selectedAccount',
          data.getAccountSelected,
          null,
          '/discover/selectAccount',
        ),
      ];
    case '/discover/singleResult':
      return [
        data.tagConstructor(
          1,
          'discover.DiscoverAndList',
          data.getDiscoverMarket,
          'SOURCE_MARKETPLACE',
          '/discover/source',
          true,
        ),
        data.tagConstructor(
          2,
          'discovery.method',
          data.getDiscoverMethod,
          'discoveryMethods',
          '/discover/ids',
          true,
        ),
        data.tagConstructor(
          3,
          'discovery.destination',
          data.getListingMarket,
          'destinationMarketplace',
          '/discover/listingSelect',
          true,
        ),
        data.tagConstructor(
          4,
          'discover.selectedAccount',
          data.getAccountSelected,
          null,
          '/discover/selectAccount',
          true,
        ),
        data.tagConstructor(
          5,
          'discovery.strategy',
          data.getStrategy,
          'pricingStrategies',
          '/discover/strategy',
          true,
        ),
      ];
    case '/discover/multiResult':
      return [
        data.tagConstructor(
          1,
          'discover.DiscoverAndList',
          data.getDiscoverMarket,
          'SOURCE_MARKETPLACE',
          '/discover/source',
          true,
        ),
        data.tagConstructor(
          2,
          'discovery.method',
          data.getDiscoverMethod,
          'discoveryMethods',
          '/discover/ids',
          true,
        ),
        data.tagConstructor(
          3,
          'discovery.destination',
          data.getListingMarket,
          'destinationMarketplace',
          '/discover/listingSelect',
          true,
        ),
        data.tagConstructor(
          4,
          'discover.selectedAccount',
          data.getAccountSelected,
          null,
          '/discover/selectAccount',
          true,
        ),
        data.tagConstructor(
          5,
          'discovery.strategy',
          data.getStrategy,
          'pricingStrategies',
          '/discover/strategy',
          true,
        ),
      ];
    default:
      return [];
  }
};

/**
 *
 * @param {object} list single q list
 * @param {number} id id of the discovery to delete
 * category[0] - is the key of the category
 * category[1] - is the value of the category
 * deleting the discovery from all the categories by id
 */
export const filterQListById = (list, id) =>
  Object.entries(list).reduce((result, category) => {
    const filteredByID = category[1].filter(discovery => discovery.id !== id);
    result[category[0]] = filteredByID;
    return result;
  }, {});

/* eslint-disable */
export const filterUndefinedValues = object =>
  Object.entries(object).reduce((result, keyValue) => {
    if (keyValue[1] !== undefined) {
      if (keyValue[0] === 'quantity') {
        result[keyValue[0]] = Number(keyValue[1]);
      } else if (keyValue[0] === 'templates') {
        result['html_template_system_id'] = keyValue[1];
      } else {
        result[keyValue[0]] = keyValue[1];
      }
    }
    return result;
  }, {});
/* eslint-enable */

// TODO CHECK THIS AND REMOVE
export const convertApiCallKeys = key => {
  switch (key) {
    case 'templates':
      return 'htmlTemplateSystemId';
    case 'categories':
      return 'selectedDestinationCategoryId';
    case 'policies':
      return 'selectedBusinessPolicyId';
    default:
      return key;
  }
};

export const convertApiCallKeysReverse = key => {
  switch (key) {
    case 'htmlTemplateSystemId':
      return 'templates';
    case 'selectedDestinationCategoryId':
      return 'categories';
    case 'selectedBusinessPolicyId':
      return 'policies';
    default:
      return key;
  }
};

export const convertDestinationMarketsEnumsToStrings = eNum => {
  switch (eNum) {
    case 11:
      return 'EBAY_ES';
    case 10:
      return 'EBAY_FR';
    case 9:
      return 'EBAY_IT';
    case 8:
      return 'EBAY_DE';
    case 7:
      return 'EBAY_CA';
    case 6:
      return 'EBAY_GB';
    case 5:
      return 'AZD_US';
    case 4:
      return 'EBAY_US';
    case 2:
      return 'WM';
    default:
      return '';
  }
};

export const convertSourceMarketsEnumsToStrings = eNum => {
  switch (eNum) {
    case 8:
      return 'AZ_CA';
    case 7:
      return 'AZ_UK';
    case 12:
      return 'AZ_DE';
    case 13:
      return 'AZ_IT';
    case 14:
      return 'AZ_FR';
    case 15:
      return 'AZ_ES';
    case 5:
      return 'CATALOG';
    case 4:
      return 'ALI_US';
    case 3:
      return 'ALI_CN';
    // case 4:
    // case 3:
    //   return 'ALI';
    case 2:
      return 'WM';
    case 1:
      return 'AZ_US';
    case 9:
      return 'CJ_US';
    case 10:
      return 'CJ_CN';
    default:
      return '';
  }
};

export const convertCurrencyToStrings = eNum => {
  switch (eNum) {
    case 1:
      return 'USD';
    default:
      return '';
  }
};

export const convertStrategyTypeToString = eNum => {
  switch (eNum) {
    case 1:
      return 'fixedProfit';
    default:
      return '';
  }
};

export const createStrategyProperties = (response, strategyType, TYPE_OF_DISCOVERY_PROFIT_TYPE) => {
  const newPropertiesStructure = response;
  newPropertiesStructure.profitType = response.inPercents
    ? TYPE_OF_DISCOVERY_PROFIT_TYPE.PERCENT
    : TYPE_OF_DISCOVERY_PROFIT_TYPE.CURRENCY_UNITS;
  delete newPropertiesStructure.inPercents;
  newPropertiesStructure.strategyType = strategyType;
  return newPropertiesStructure;
};

export const convertConditionToNumber = parsedConfig => {
  if (parsedConfig.propsToUpdate.condition) {
    parsedConfig.propsToUpdate.condition = Number(parsedConfig.propsToUpdate.condition);
  }
  return parsedConfig.propsToUpdate;
};

export const checkForVeroFailedWordsToUpdate = data => {
  const object = {};
  if (data.descriptionFailedWords != null && data.descriptionFailedWords.length > 0)
    object.descriptionFailedWords = data.descriptionFailedWords;
  if (data.titleFailedWords != null && data.titleFailedWords.length > 0)
    object.titleFailedWords = data.titleFailedWords;
  if (data.brandFailedWords != null && data.brandFailedWords.length > 0)
    object.brandFailedWords = data.brandFailedWords;

  return object;
};

export const getRegexForUrlValidation = (marketplaceId, SOURCE_MARKETPLACE) => {
  switch (marketplaceId) {
    case SOURCE_MARKETPLACE.WALMART:
      return /\/ip\/\.*/;
    case SOURCE_MARKETPLACE.AMAZON_US:
      return RegExp('https://www.amazon.com/([\\w-]+/)?(dp|gp/product)/(\\w+/)?(\\w{10})');
    default:
      return /\w*([\W\w])/g;
  }
};

const getAsinFromUrl = url => {
  const regex = RegExp('https://www.amazon.com/([\\w-]+/)?(dp|gp/product)/(\\w+/)?(\\w{10})');
  const m = url.match(regex);
  return [m[4]];
};

const getAsinFromUrlForUK = url => {
  const regex = RegExp('https://www.amazon.co.uk/([\\w-]+/)?(dp|gp/product)/(\\w+/)?(\\w{10})');
  const m = url.match(regex);
  return [m[4]];
};

const getAsinFromUrlForCA = url => {
  const regex = RegExp('https://www.amazon.ca/([\\w-]+/)?(dp|gp/product)/(\\w+/)?(\\w{10})');
  const m = url.match(regex);
  return [m[4]];
};

const getAsinFromUrlForDE = url => {
  const regex = RegExp('https://www.amazon.de/([\\w-]+/)?(dp|gp/product)/(\\w+/)?(\\w{10})');
  const m = url.match(regex);
  return [m[4]];
};

const getAsinFromUrlForFR = url => {
  const regex = RegExp('https://www.amazon.fr/([\\w-]+/)?(dp|gp/product)/(\\w+/)?(\\w{10})');
  const m = url.match(regex);
  return [m[4]];
};

const getAsinFromUrlForES = url => {
  const regex = RegExp('https://www.amazon.es/([\\w-]+/)?(dp|gp/product)/(\\w+/)?(\\w{10})');
  const m = url.match(regex);
  return [m[4]];
};

const getAsinFromUrlForIT = url => {
  const regex = RegExp('https://www.amazon.it/([\\w-]+/)?(dp|gp/product)/(\\w+/)?(\\w{10})');
  const m = url.match(regex);
  return [m[4]];
};

const getAsinFromUrlForCJ = url => {
  const regex = /-p-([^.]*)\.html/;
  const m = url.match(regex);
  return [m[1]];
};

const getAliExpId = url => [/https:\/\/www\.aliexpress\.com\/item\/(\d+)\.html/.exec(url)[1]];

export const getIdForUrl = (url, marketplaceId, SOURCE_MARKETPLACE) => {
  switch (marketplaceId) {
    case SOURCE_MARKETPLACE.WALMART:
      return [url[0].substr(url[0].lastIndexOf('/') + 1).split('?')[0]];
    case SOURCE_MARKETPLACE.AMAZON_US:
      return getAsinFromUrl(url[0]);
    case SOURCE_MARKETPLACE.ALIEXPRESS_US:
    case SOURCE_MARKETPLACE.ALIEXPRESS_CN:
      return getAliExpId(url[0]);
    case SOURCE_MARKETPLACE.AMAZON_UK:
      return getAsinFromUrlForUK(url[0]);
    case SOURCE_MARKETPLACE.AMAZON_CA:
      return getAsinFromUrlForCA(url[0]);
    case SOURCE_MARKETPLACE.AMAZON_DE:
      return getAsinFromUrlForDE(url[0]);
    case SOURCE_MARKETPLACE.AMAZON_IT:
      return getAsinFromUrlForIT(url[0]);
    case SOURCE_MARKETPLACE.AMAZON_FR:
      return getAsinFromUrlForFR(url[0]);
    case SOURCE_MARKETPLACE.AMAZON_ES:
      return getAsinFromUrlForES(url[0]);
    case SOURCE_MARKETPLACE.CJ_US:
      return getAsinFromUrlForCJ(url[0]);
    default:
      return /\w*([\W\w])/g;
  }
};
